import React, { createContext, useContext, useState } from 'react';

const DashboardContext = createContext(null);

export const DashboardProvider = ({ children }) => {
    const [agentType, setAgentType] = useState(['ONLINE', 'OFFLINE', 'BULK']);
    const [configIds, setConfigIDs] = useState({ mId: '', fMId: '', tLId: '' });

    const handleViewManagerWise = (mID, fmID, tlID) => {
        setConfigIDs({ mId: mID, fMId: fmID, tLId: tlID });
    };

    return (
        <DashboardContext.Provider value={{ agentType, setAgentType, configIds, handleViewManagerWise }}>
            {children}
        </DashboardContext.Provider>
    );
};

export const useDashboard = () => useContext(DashboardContext);
